<main>
    <div class="main_menu">
        <img *ngIf="imgGot == true" (click)="go('/accueil/profil')" class="menus_avatar" src="{{imgUrl | async}}" alt="avatar">
        <img *ngIf="imgGot == false" (click)="go('/accueil/profil')" class="menus_avatar" src="../../../assets/icons/default_avatar.svg">
        <p class="menus_name">
            <b>{{userData.username}}</b>
        </p>
        <div class="menus_tabs">
            <div class="menus_tab">
                <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
            </div>
            <div class="menus_tab menu_rapports" (click)="go('/admin')">
                <p>Rapports</p>
            </div>
            <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                <p>Évènements</p>
            </div>
            <div class="menus_deconnexion" (click)="signOut()">
                <p style="color: red; font-weight: 500;
                    position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
            </div>
        </div>
    </div>
    <div class="mobile_menu">
        <img *ngIf="imgGot == true" (click)="manageDropDown()" class="menus_avatar" src="{{imgUrl | async}}" alt="avatar">
        <img *ngIf="imgGot == false" (click)="manageDropDown()" src="../../../assets/icons/default_avatar.svg" class="menus_avatar">
        <div class="menus_tabs">
            <div class="menus_tab">
                <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
            </div>
            <div class="menus_tab menu_accueil" (click)="go('/admin')">
                <p>Rapports</p>
            </div>
            <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                <p>Évènements</p>
            </div>
        </div>
        <div class="menu_dropdown">
            <hr>
            <p class="dropdown_profil" (click)="this.app.navigateTo('/accueil/profil')">
                {{userData.username}} -&emsp;
                <!--<b class="menus_stars">{{userData.medailles_count.toFixed(1)}}</b>
                <span class="material-icons">grade</span>
                <span class="material-icons chevron_right">chevron_right</span> -->
            </p>
            <p (click)="signOut()" style="color: red; font-weight: 500;
                    position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
        </div>
    </div>
</main>